"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24",
    fill: "#004864"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M18.9,18.66,14.4,14.16a6,6,0,0,0,1.33-3.74,6.07,6.07,0,1,0-6.07,6.07,6,6,0,0,0,3.74-1.33l4.49,4.49a.7.7,0,0,0,1-1ZM5,10.42a4.66,4.66,0,1,1,4.66,4.66A4.67,4.67,0,0,1,5,10.42Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.8,7.72a.5.5,0,0,1-.27-.08,2.11,2.11,0,0,0-1.64-.1.5.5,0,0,1-.35-.94,3.1,3.1,0,0,1,2.53.19.5.5,0,0,1-.27.92Z"
  }));
};

exports["default"] = _default;